import { Pipe, PipeTransform } from '@angular/core';
import { AppVersionStatus, AppVersionStatusDesc } from '#models/enum/system-version-status';

@Pipe({name: 'appVersionStatus'})
export class AppVersionStatusPipe implements PipeTransform {
    transform(value: AppVersionStatus) {
        return AppVersionStatusDesc.map.get(value);
    }
}
